import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { RolesModel } from '../../models/roles.model';
import { ITableState, TableResponseModel } from '../../models/table.model';
import { TableService } from '../../table.service';

@Component({
	template: ``
})

export class RolesTableComponent extends TableService<RolesModel> {

	constructor(
		@Inject(HttpClient) http
	) {
		super(http);
	}

	/**
	 * Handle create address
	 * @param item : Address data object
	 * @returns
	 */
	createRole(item: RolesModel): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ROLES.CREATE;
		// return this.create(item, url);
	}

	/**
	 * Handle item update
	 * @param item : Updated data object
	 * @returns
	 */
	updateRole(item: RolesModel): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ROLES.CREATE + `/${item.id}`;
		return this.update(item, url);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	*/
	findRoles(tableState: ITableState): Observable<TableResponseModel<RolesModel>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ROLES.SEARCH;
		return this.find(url);
	}

	/**
	 * Delete list of items by ids
	 */
	deleteRoles(ids: number[] = []): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ROLES.DELETE;
		// return this.deleteItems(ids, url);
	}
}
